import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/network/StatusPill";

const fmt = (v) => (v ? new Date(v).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "short", timeStyle: "short" }) : "-");
const spName = (s) => (s.deleted ? `${s.kode || ""} (terhapus)`.trim() : s.kode || "(terhapus)");
const text = (r, label) => (r.direction === "in"
  ? `Splitter ${spName(r.splitter)} output ${r.output_port} → ${label}`
  : `${label} → input Splitter ${spName(r.splitter)}`);

// Relasi splitter (read-only) untuk detail ODC/ODP.
export function SplitterRelations({ kind, id, kode, onSelect }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get(`/network/${kind}/${id}/splitter-relations`).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  }, [kind, id]);
  const label = `${kind.toUpperCase()} ${kode}`;
  return (
    <section className="rounded border border-[#E5E7EB] p-2 text-xs" data-testid={`${kind}-splitter-relations`}>
      <div className="mb-1 font-bold uppercase text-[#6B7280]">Relasi Splitter</div>
      {!d ? <p className="text-[#6B7280]">Memuat…</p> : d.error ? <p className="text-[#B91C1C]">Gagal memuat relasi splitter.</p> : <>
        {!d.active.length && <p className="text-[#6B7280]" data-testid={`${kind}-splitter-rel-empty`}>Tidak ada relasi splitter aktif.</p>}
        <ul className="space-y-1">{d.active.map((r) => (
          <li key={r.id} className="flex flex-wrap items-center gap-2" data-testid={`${kind}-splitter-rel-${r.id}`}>
            <span className="rounded bg-[#EFF6FF] px-1.5 text-[10px] font-semibold text-[#1D4ED8]">{r.direction === "in" ? "MASUK" : "KELUAR"}</span>
            <button type="button" className="font-semibold text-[#0055FF] disabled:text-inherit" disabled={!onSelect || !r.splitter.kode}
                    onClick={() => onSelect?.({ kind: "splitter", id: r.splitter.id })}>{text(r, label)}</button>
            {r.splitter.rasio && <span className="text-[#6B7280]">({r.splitter.rasio})</span>}
            <span className="text-[#15803D]">Relasi aktif</span>
            {r.splitter.status && <span className="flex items-center gap-1 text-[#6B7280]">splitter <StatusPill status={r.splitter.status} /></span>}
            <span className="text-[#6B7280]">sejak {fmt(r.started_at)}</span>
          </li>))}</ul>
        {d.history.length > 0 && (
          <details className="mt-1" data-testid={`${kind}-splitter-rel-history`}>
            <summary className="cursor-pointer font-semibold text-[#6B7280]">Riwayat terputus ({d.history.length})</summary>
            <ul className="mt-1 space-y-1">{d.history.map((r) => (
              <li key={r.id} className="rounded bg-[#F8F9FA] p-1.5">{text(r, label)}
                <span className="text-[#6B7280]"> · {fmt(r.started_at)} s/d {fmt(r.ended_at)} · {r.end_reason}</span></li>))}</ul>
          </details>
        )}
      </>}
    </section>
  );
}
